import React from "react";

/**
 * Switch de "Modo profesor" para la previsualización de actividades del constructor.
 *
 * Es solo de vista: alterna entre la actividad interactiva (como la ve el alumno)
 * y la actividad resuelta (como la ve el profesor). No guarda nada en el bloque.
 *
 * Los visores usan la convención de `ModoVisorPDF`:
 *   evaluable={true}  -> interactiva, sin respuestas
 *   evaluable={false} -> resuelta, con respuestas
 * por lo que quien lo use debe pasar `evaluable={!modoProfesor}`.
 *
 * Replica el aspecto de `ProfesorSwitch` (el switch azul de la vista previa del
 * constructor) a propósito, en vez de importarlo: este flujo debe quedar aislado
 * del constructor y de la generación de PDF/DOCX, que ya funcionan.
 */
const ModoProfesorSwitch = ({ modoProfesor, setModoProfesor }) => {
  if (typeof setModoProfesor !== "function") return null;

  return (
    <div
      title="Ver la actividad resuelta, como la vería el profesor"
      onClick={() => setModoProfesor(!modoProfesor)}
      className={`relative w-[138px] h-[30px] flex items-center rounded-full px-2 cursor-pointer transition-colors duration-300 shadow-xl select-none ${
        modoProfesor ? "bg-[#18BAFB]" : "bg-gray-300"
      }`}
    >
      <div
        className={`h-[24px] w-[24px] rounded-full bg-white shadow-md transition-transform duration-300 absolute ${
          modoProfesor ? "translate-x-[103px]" : "-translate-x-[5px]"
        }`}
      />
      <span className="text-white text-sm mx-auto">PROFESOR</span>
    </div>
  );
};

export default ModoProfesorSwitch;
